import styled from 'styled-components/macro';

import { StyledDiv } from 'components/base/AnimatedLoadingWrapper';

export const HeaderContainer = styled(StyledDiv)`
  display: flex;
  align-items: center;
  padding: calc(100px - ${({ theme }): string => theme.spacing.xlarge}) 0
    calc(55px - ${({ theme }): string => theme.spacing.xlarge}) 0;
  transition: ${({ theme }): string =>
    `opacity ${theme.transitionDuration} ${theme.timingFunction}`};
  opacity: ${({ loading }): number => (loading ? 0 : 1)};
`;

export const Header = styled('header')`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  align-items: center;
  padding: ${({ theme }): string => theme.spacing.xlarge} 0;
  text-align: center;
  color: #ffffff;

  @media screen and (min-width: 40em) {
    text-align: left;
    flex-flow: row nowrap;
    padding: ${({ theme }): string => theme.spacing.xxlarge} 0;
    justify-content: center;
  }
`;

export const ContentWrapper = styled('div')`
  @media screen and (min-width: 40em) {
    width: auto;
  }
`;

export const MobileWrapper = styled('div')`
  text-align: left;
  padding-left: 20px;
  @media screen and (min-width: 40em) {
    text-align: unset;
    padding-left: unset;
  }
`;

export const IconWrapper = styled('div')`
  @media screen and (min-width: 40em) {
    margin-right: 22px;
    margin-bottom: 8px;
  }
`;

export const SmallTitle = styled('div')`
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 11px;
  @media screen and (min-width: 40em) {
    font-size: 12px;
  }
`;

export const GoToTitle = styled('div')`
  color: #ffffff;
  font-size: 13px;
  box-shadow: 0px 1.5px 0px 0px #ffffff;
  width: fit-content;
  display: inline-block;

  &:hover {
    box-shadow: 0px 2px 0px 0px #ffffff;
  }

  a {
    box-shadow: none;
  }
  a:hover {
    box-shadow: none;
  }
  a:focus,
  a:active {
    color: unset;
    background: none;
  }

  svg {
    color: #ffffff;
    height: 10px;
    margin-left: 5px;
  }

  @media screen and (min-width: 40em) {
    font-size: 16px;
  }
`;

export const Title = styled('div')`
  font-size: 20px;
  line-height: 24px;

  @media screen and (min-width: 40em) {
    font-size: 44px;
    line-height: 45px;
  }
`;
